import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";
import useUserPermission from "~/hooks/useUserPermission";

export const useDatasetAssistant = (): boolean => {
  const user = useUser();
  const fliptEnabled = useFliptBoolean("dataset-chat-agent", false, user?.email);
  const hasUseAiAgentsPermission = useUserPermission("use:ai-agents");
  return fliptEnabled || hasUseAiAgentsPermission;
};

export default useDatasetAssistant;
